import React from "react";
import Rodal from "rodal";
import "rodal/lib/rodal.css";
import { PropTypes } from "prop-types";

class EmailModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = { visible: false };
  }

  render() {
    return (
      <div>
        <Rodal
          visible={this.props.show}
          onClose={this.props.hide}
          width={Number("600")}
          height={Number("400")}
        >
          <div style={{ padding: "20px", paddingTop: "5px" }}>
            {this.props.children}
          </div>
        </Rodal>
      </div>
    );
  }
}

EmailModal.propTypes = {
  show: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.bool
  ]),
  hide:PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.bool
  ]),
  children: PropTypes.node
}

export default EmailModal;
